import { HttpError } from "@bps/http-client";
import { UndefinedInitialDataOptions, useQuery } from "@tanstack/react-query";

import { useGateways } from "../../gateways-context";
import { CloudApplicationDto } from "./bp-id.dtos";

enum BpIdCacheKeys {
  bpidCloudApplications = "bpid-cloud-applications"
}

export const useRefCloudApplications = <TSelectData = CloudApplicationDto[]>(
  options?: Partial<
    UndefinedInitialDataOptions<CloudApplicationDto[], HttpError, TSelectData>
  >
) => {
  const {
    bpIdApi: { getCloudApplications }
  } = useGateways();

  return useQuery<CloudApplicationDto[], HttpError, TSelectData>({
    ...options,
    queryKey: [BpIdCacheKeys.bpidCloudApplications],
    queryFn: getCloudApplications,
    staleTime: Infinity,
    gcTime: Infinity
  });
};
